<template>
  <div class="AgentCategoryShareViewContainer">
    <nut-tabs v-model="tab" type="smile" class="mt12" auto-height>
      <template v-for="(t,ti) in secondCategories" :key="`categories_${ti}`">
        <nut-tabpane :title="t.label" :pane-key="ti" style="padding: 0 16px;height: 88vh">
          <InfiniteLoadingList :query-id="4"
                               :init-query="{'token':token,secondCategory:t.id}" @load="onLoad">
            <template v-slot="data">
              <SaleShareCard :data="data.data" @click="$router.push('/d/'+data.data.goodToken)"/>
            </template>
          </InfiniteLoadingList>
        </nut-tabpane>
      </template>
    </nut-tabs>
  </div>
</template>

<script>
import SaleShareCard from "@/components/sale/SaleShareCard";
import InfiniteLoadingList from "@/components/InfiniteLoadingList";
import api from "@/api";

export default {
  name: "AgentCategoryShareView",
  components: {SaleShareCard, InfiniteLoadingList},
  data() {
    return {
      token: this.$route.params.token,
      horse: [],
      initState: false,
      secondCategories: [{
        id: 0,
        label: '全部'
      }],
      tab: 0,
    }
  },
  methods: {
    onLoad(ls) {
      if (this.initState || !ls || ls.length < 1) {
        return
      }
      console.log('onLoad', ls)
      this.initState = true;
      const first = ls[0];
      if (!first?.operates.detail) {
        //二级类目分享，不加载全部类目
        return
      }
      api.getEnumOptions({
        type: 0,
        refId: first.categoryId
      }).then(ret => {
        this.secondCategories.push(...ret)
      })
    },
    init() {

    }
  },
  mounted() {
    this.init()
  },
  unmounted() {
  }
}
</script>

<style lang="scss" scoped>
.AgentCategoryShareViewContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
}
</style>